import React, { useEffect, useMemo, useState } from 'react';
import * as turf from '@turf/turf';
import { MarkerAndPopover } from '@/components/markers/markerandpopover';
import { useMapContext } from '@/contexts/MapContext';
import { useMapFilterContext } from '@/contexts/MapFilterContext';
import { fetchSudsData } from '@/libs/suds-data-fetch';
import { markerConfig } from '../markerconfig';

export function SudsMarkers({ zIndex }: { zIndex: string }) {
  const { map, mapFilterPolygon } = useMapContext();
  const { showSudsMarkers, sudsTypeFilter } = useMapFilterContext();
  const [sudsData, setSudsData] = useState<any>(null);

  useEffect(() => {
    async function getData() {
      try {
        const data = await fetchSudsData();

        setSudsData(data);
      } catch (error) {
        console.error('Error fetching SUDS data:', error);
      }
    }

    getData();
  }, []);

  const filteredSuds = useMemo(() => {
    if (!map || !sudsData || !mapFilterPolygon) {
      return null;
    }
    return (
      <>
        {sudsData.features.map(
          (
            feature: {
              type: string;
              geometry: { coordinates: any; type: string };
              properties: {
                sudsType: string;
                sudsSubType: string;
                description: string;
                location: string;
                siteType: string;
              };
            },
            index: React.Key | null | undefined
          ) => {
            const point = [
              parseFloat(feature.geometry.coordinates[0]),
              parseFloat(feature.geometry.coordinates[1]),
            ];

            const isInPolygon = turf.booleanPointInPolygon(point, mapFilterPolygon);
            const isInTypeFilterList = sudsTypeFilter.includes(feature.properties.sudsType);

            if (isInPolygon && isInTypeFilterList) {
              return (
                <MarkerAndPopover
                  key={index}
                  map={map}
                  geoJsonData={{ features: [feature] }}
                  config={markerConfig.suds}
                  zIndex={zIndex}
                />
              );
            }
            return null;
          }
        )}
      </>
    );
  }, [sudsData, mapFilterPolygon, sudsTypeFilter]);

  if (!showSudsMarkers || !filteredSuds) {
    return null;
  }

  return filteredSuds;
}
